import { render, staticRenderFns } from "./CaseDashboardCard.vue?vue&type=template&id=30bfacd3&scoped=true&"
import script from "./CaseDashboardCard.vue?vue&type=script&lang=ts&"
export * from "./CaseDashboardCard.vue?vue&type=script&lang=ts&"
import style0 from "./CaseDashboardCard.vue?vue&type=style&index=0&id=30bfacd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bfacd3",
  null
  
)

export default component.exports